import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleHourglass = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 12.5C2.25 7.11522 6.61522 2.75 12 2.75C17.3848 2.75 21.75 7.11522 21.75 12.5C21.75 17.8848 17.3848 22.25 12 22.25C6.61522 22.25 2.25 17.8848 2.25 12.5Z",
			fill: "#E1EFFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 12.5C2.25 7.11522 6.61522 2.75 12 2.75C17.3848 2.75 21.75 7.11522 21.75 12.5C21.75 17.8848 17.3848 22.25 12 22.25C6.61522 22.25 2.25 17.8848 2.25 12.5Z",
			stroke: "#76A9FA",
			strokeWidth: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5715 16.7857H15.863V16.1457C15.863 15.5057 15.6001 14.8771 15.1487 14.4257L13.2115 12.5L15.1487 10.5743C15.6001 10.1229 15.863 9.5 15.863 8.85429V8.21429H16.5715C17.0458 8.21429 17.4287 7.83143 17.4287 7.35714C17.4287 6.88286 17.0458 6.5 16.5715 6.5H7.42868C6.95439 6.5 6.57153 6.88286 6.57153 7.35714C6.57153 7.83143 6.95439 8.21429 7.42868 8.21429H8.13725V8.85429C8.13725 9.49429 8.4001 10.1229 8.85153 10.5743L10.7887 12.5L8.85153 14.4257C8.4001 14.8771 8.13725 15.5 8.13725 16.1457V16.7857H7.42868C6.95439 16.7857 6.57153 17.1686 6.57153 17.6429C6.57153 18.1171 6.95439 18.5 7.42868 18.5H16.5715C17.0458 18.5 17.4287 18.1171 17.4287 17.6429C17.4287 17.1686 17.0458 16.7857 16.5715 16.7857ZM10.0572 9.35714C9.92582 9.22571 9.85153 9.04286 9.85153 8.85429V8.21429H14.1544V8.85429C14.1544 9.04286 14.0801 9.22571 13.943 9.35714L12.0001 11.2886L10.0572 9.35714ZM9.85153 16.14C9.85153 15.9514 9.92582 15.7686 10.063 15.6371L12.0058 13.7057L13.9487 15.6371C14.0801 15.7686 14.1544 15.9514 14.1544 16.14V16.78H9.85153V16.14Z",
			fill: "#1E429F"
		})
	]
});
export default SvgCircleHourglass;
